export const alertShortCutAction = {
    SET_SHORT_CUT: 'SET_SHORT_CUT',
    REMOVE_SHORT_CUT: 'REMOVE_SHORT_CUT',
  }